export enum CurrencyEnum {
  cad = 'CAD',
  usd = 'USD',
}

export const numberToDollars = (
  value: number,
  locale = { region: 'en-US', currency: 'USD' },
  fractionDigits?: number
): string => {
  const formatter = new Intl.NumberFormat(locale.region, {
    style: 'currency',
    currency: locale.currency,
    minimumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
    maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
  })
  return formatter.format(value)
}

const regionOtherThanCanada = 'en-US'
const numberToCanadianDollars = (value: number) =>
  numberToDollars(value, { region: regionOtherThanCanada, currency: 'CAD' })

export const numberToCurrency = (value: number, currency: CurrencyEnum) => {
  const formatters = {
    [CurrencyEnum.cad]: numberToCanadianDollars,
    [CurrencyEnum.usd]: numberToDollars,
  }
  return formatters[currency](value)
}

export const currencyStringToNumber = (value: string = ''): number =>
  Number(value.replace(/[^0-9.-]+/g, ''))
